<div class="consent-panel">
  <div class="header">
    {{'chat_bot_consent.header_title_h' | translate}}
    <rs-web-icon
      [icon]="immomioIconName.Close"
      [size]="20"
      [cursor]="'pointer'"
      (click)="closed.emit()"
    ></rs-web-icon>
  </div>

  <div class="consent-content">
    <div class="orb-container">
      <img class="orb" alt="ida-chatbot-button" src="/web/images/gif/ida.gif" />
    </div>

    <div class="title">{{'chat_bot_consent.title_h' | translate}}</div>

    <div [innerHTML]="legalText()"></div>

    <div class="form-check" (click)="consentCheckbox.click()">
      <rs-web-form-field>
        <input
          (click)="$event.stopPropagation()"
          #consentCheckbox
          class="form-check-input"
          name="consent"
          type="checkbox"
        />
        <label class="form-check-label d-flex flex-row" for="consent">
          * {{ 'chat_bot_consent.check_box_l' | translate }}
        </label>
      </rs-web-form-field>
    </div>

    <button
      im-button
      class="primary"
      [disabled]="!consentCheckbox.checked"
      (click)="consentAccepted.emit()"
    >
      {{ 'chat_bot_consent.accept_btn_l' | translate }}
    </button>
  </div>
</div>
